export const SUPPORTED_PROJECTOR_MAKES = ["BenQ", "EPSON", "Optoma"] as const

export type ProjectorMake = (typeof SUPPORTED_PROJECTOR_MAKES)[number]
